<script setup>
import PersistentTooltip from '#/general/PersistentTooltip'
defineProps({
  offset: Array,
  contentWidth: String
})
</script>

<template lang="pug">
persistent-tooltip(
  :offset="offset"
  :content-width="contentWidth"
  title-color="#5FEFC0"
  title="Total Score"
)
  template(#body)
    .score-tooltip--content
      div Ein hoher Wert bedeutet, dass es sich lohnt, die Möglichkeiten einer Aufwertung der Parzelle abzuklären. Der Total-Score wird von folgenden Faktoren beeinflusst:
      ul
        li Ausnutzungsreserven
        li Parzellengrösse
        li Lage
        li Sanierungsdruck
      div Anders ausgedrückt: Ein Wert nahe bei 100 würde bedeuten, dass auf der Parzelle deutlich mehr Wohnraum stehen könnte.
  template(#icon)
    .methodContainer
      svg(width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg')
        circle(cx='11' cy='11' r='11' fill='#EB604F')
        path(d='M10.0953 9.624H11.9033V14H10.0953V9.624ZM10.9993 9.272C10.674 9.272 10.41 9.18667 10.2073 9.016C10.01 8.84 9.91131 8.61867 9.91131 8.352C9.91131 8.08533 10.01 7.86667 10.2073 7.696C10.41 7.52 10.674 7.432 10.9993 7.432C11.33 7.432 11.594 7.51467 11.7913 7.68C11.9886 7.84533 12.0873 8.05867 12.0873 8.32C12.0873 8.59733 11.9886 8.82667 11.7913 9.008C11.594 9.184 11.33 9.272 10.9993 9.272Z' fill='white')
        circle(cx='11' cy='11' r='6.4' stroke='white' stroke-width='1.2')
        circle(cx='11' cy='11' r='6.4' stroke='white' stroke-width='1.2')
  template(#chip)
    .methodContainer
      svg(width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg')
        circle(cx='11' cy='11' r='11' fill='#EB604F')
        path(d='M10.0953 9.624H11.9033V14H10.0953V9.624ZM10.9993 9.272C10.674 9.272 10.41 9.18667 10.2073 9.016C10.01 8.84 9.91131 8.61867 9.91131 8.352C9.91131 8.08533 10.01 7.86667 10.2073 7.696C10.41 7.52 10.674 7.432 10.9993 7.432C11.33 7.432 11.594 7.51467 11.7913 7.68C11.9886 7.84533 12.0873 8.05867 12.0873 8.32C12.0873 8.59733 11.9886 8.82667 11.7913 9.008C11.594 9.184 11.33 9.272 10.9993 9.272Z' fill='white')
        circle(cx='11' cy='11' r='6.4' stroke='white' stroke-width='1.2')
        circle(cx='11' cy='11' r='6.4' stroke='white' stroke-width='1.2')
</template>

<style scoped lang="sass">

</style>
